const DefinitionHandleSelect = (row, indx, idIndex, argPayload) => {
  const { defaultSelectedIds, unselectedRows, selectedRows, setSelectedRows, setUnselectedRows, courseList } =
    argPayload;

  const targetRow = {
    id: row[idIndex],
    value: !row.at(-1),
  };

  courseList[indx][courseList[indx].length - 1] = targetRow.value;
  const isDefaultSelectedCourse = defaultSelectedIds.includes(targetRow.id);

  if (targetRow.value) {
    if (isDefaultSelectedCourse) {
      // deletes re-checked row from unselectedRows
      const newArr = unselectedRows.filter(course => course.id !== targetRow.id);

      setUnselectedRows(Array.from(newArr));
    } else if (!selectedRows.some(course => course.id === targetRow.id)) {
      setSelectedRows([...selectedRows, targetRow]);
    }

    return;
  }

  if (isDefaultSelectedCourse) {
    // adds unselected row that was originally selected
    if (!unselectedRows.some(course => course.id === targetRow.id)) {
      setUnselectedRows([...unselectedRows, targetRow]);
    }

    return;
  }

  const newArr = selectedRows.filter(course => course.id !== targetRow.id);
  setSelectedRows(newArr);
};

export default DefinitionHandleSelect;
